import(/* webpackMode: "eager" */ "/app/apps/planner/src/app/error.tsx");
